import type { ClientDetails } from '@peloton/analytics/clientDetailsHeader';
import { toClientDetailsHeader } from '@peloton/analytics/clientDetailsHeader';
import type { Client } from '@peloton/api/utils';

export const createBookmarkForClass = <
  BookmarkAnalyticsProps extends Record<string, any>,
>(
  api: Client,
  classId: string,
  analytics: ClientDetails<BookmarkAnalyticsProps>,
) =>
  api.post(
    '/api/favorites/create',
    { rideId: classId },
    toClientDetailsHeader(analytics),
  );

export const deleteBookmarkForClass = <
  BookmarkAnalyticsProps extends Record<string, any>,
>(
  api: Client,
  classId: string,
  analytics: ClientDetails<BookmarkAnalyticsProps>,
) =>
  api.post(
    '/api/favorites/delete',
    { rideId: classId },
    toClientDetailsHeader(analytics),
  );
